/**
 * Album identity access enum.
 *
 * @enum ALBUM_IDENTITY_ACCESS
 * @type {{ALL: string, PRIMARY_ONLY: string, SECONDARY_ONLY: string}}
 */
export const ALBUM_IDENTITY_ACCESS = {
  ALL: 'ALL',
  PRIMARY_ONLY: 'PRIMARY_ONLY',
  SECONDARY_ONLY: 'SECONDARY_ONLY',
  NONE: 'NONE',
};

/**
 * Identity relationship enum.
 *
 * @enum IDENTITY_RELATIONSHIP
 * @type {{PRIMARY: string, SECONDARY: string}}
 */
export const IDENTITY_RELATIONSHIP = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
};

/**
 * Identity selfie type enum.
 *
 * @enum IDENTITY_SELFIE_TYPE
 * @type {{USER: string, ASSIGNED: string}}
 */
export const IDENTITY_SELFIE_TYPE = {
  USER: 'USER_SELFIE',
  ASSIGNED: 'ASSIGNED_SELFIE',
};

/**
 * Identity selfie source enum.
 *
 * @enum IDENTITY_SELFIE_SOURCE
 * @type {{ADMIN_PROMOTED_FROM_MATCH: string, ADMIN_UPLOADED: string, AUTORIPS: string, ROSTER_IDENTITY: string, USER_UPLOADED: string}}
 */
export const IDENTITY_SELFIE_SOURCE = {
  ADMIN_PROMOTED_FROM_MATCH: 'ADMIN_PROMOTED_FROM_MATCH',
  ADMIN_UPLOADED: 'ADMIN_UPLOADED',
  AUTORIPS: 'AUTORIPS',
  GLOBAL_AUTORIPS: 'GLOBAL_AUTORIPS',
  ROSTER_IDENTITY: 'ROSTER_IDENTITY',
  USER_UPLOADED: 'USER_UPLOADED',
  CLONE_UPLOADED: 'CLONE_UPLOADED',
};

/**
 * Identity warning types.
 *
 * @enum IDENTITY_WARNING_TYPE
 * @type {{ACTIVE_REF_IMG_DIFFER: string, MATCHES_DIFFER: string, OTHER: string}}
 */
export const IDENTITY_WARNING_TYPE = {
  ACTIVE_REF_IMG_DIFFER: 'ACTIVE_REF_IMG_DIFFER',
  MATCHES_DIFFER: 'MATCHES_DIFFER',
  OTHER: 'OTHER',
};

/**
 * Identity warning type strings.
 */
export const IDENTITY_WARNING_STRING = {
  ACTIVE_REF_IMG_DIFFER: 'Active Reference Image Differs',
  MATCHES_DIFFER: 'Matches Differ',
  OTHER: 'Other',
};

/**
 * Identity school grades enum.
 *
 * TODO: possibly temporary until further GQL support.
 *
 * @enum IDENTITY_SCHOOL_GRADES
 */
export const IDENTITY_SCHOOL_GRADES = {
  PRE_K: 'Pre-K',
  KINDERGARTEN: 'Kindergarten',
  FIRST: '1st Grade',
  SECOND: '2nd Grade',
  THIRD: '3rd Grade',
  FOURTH: '4th Grade',
  FIFTH: '5th Grade',
  SIXTH: '6th Grade',
  SEVENTH: '7th Grade',
  EIGHTH: '8th Grade',
  NINTH: '9th Grade',
  TENTH: '10th Grade',
  ELEVENTH: '11th Grade',
  TWELFTH: '12th Grade',
  THIRTEENTH: '13th Grade',
  FOURTEENTH: '14th Grade',
  FIFTEENTH: '15th Grade',
};

/**
 * Identity gender enum.
 *
 * @enum IDENTITY_GENDER
 * @type {{MALE: string, FEMALE: string}}
 */
export const IDENTITY_GENDER = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
};

/**
 * Identity share status enum
 *
 * @enum IDENTITY_SHARE_STATUS
 * @type {{ACCEPTED: string, REJECTED: string, PENDING: string}}
 */
export const IDENTITY_SHARE_STATUS = {
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  PENDING: 'PENDING',
};
